import React from 'react';

export default function Home() {
  return <div style={{ width: '1000px' }} />;
}
